// @flow
import * as React from 'react'
import uuid from 'uuid/v4'

import './SVGResponsive.scss'

export type Layout = 'widthConstrained' | 'heightConstrained' | 'inline'

export type PublicProps = {
  title?: string,
  description?: string,
  layout?: Layout,
}

export type Props = PublicProps & {
  width: number,
  height: number,
  children: React.Node,
}

const WIDTH_CONSTRAINED: Layout = 'widthConstrained'
const HEIGHT_CONSTRAINED: Layout = 'heightConstrained'
const INLINE: Layout = 'inline'

export default class SVGResponsive extends React.Component<Props> {
  static defaultProps = {
    layout: WIDTH_CONSTRAINED,
  }

  render = () => {
    const { title, description } = this.props

    const id = `id${uuid()}`
    const titleId = title ? `t${id}` : ''
    const descriptionId = description ? `d${id}` : ''
    const labeledBy = `${titleId} ${descriptionId}`

    return (
      <div className={`SVGResponsive ${this.layoutClassNameModifer}`} style={this.style}>
        <svg
          className="SVGResponsive-svg"
          viewBox={this.viewBox}
          aria-labelledby={labeledBy}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title ? renderTitle(title, titleId) : null}
          {description ? renderDescription(description, descriptionId) : null}
          {this.props.children}
        </svg>
      </div>
    )
  }

  get viewBox(): string {
    return `0 0 ${this.props.width} ${this.props.height}`
  }

  get style(): {} {
    if (this.props.layout !== WIDTH_CONSTRAINED) return {}

    const ratio = (this.props.height / this.props.width) * 100

    return { paddingBottom: `${ratio}%` }
  }

  get layoutClassNameModifer(): string {
    switch (this.props.layout) {
      case WIDTH_CONSTRAINED:
        return 'SVGResponsive--layoutWidthConstrained'

      case HEIGHT_CONSTRAINED:
        return 'SVGResponsive--layoutHeightConstrained'

      case INLINE:
        return 'SVGResponsive--layoutInline'

      default:
        return ''
    }
  }
}

function renderTitle(title, titleId) {
  return <title id={titleId}>{title}</title>
}

function renderDescription(description, descriptionId) {
  return <desc id={descriptionId}>{description}</desc>
}
